<div class="flex justify-between px-2 py-2 mb-2">
  <div class="min-w-1/3 w-2/5 text-primary dark:text-dark-text">
    <ng-content select="[appLabel]"></ng-content>
  </div>
  <div class="text-right w-3/5 text-balance break-words dark:text-dark-muted">
    <ng-content></ng-content>
  </div>
</div>
